export default {
	baseUrl: 'http://localhost:8080/ssmw7150cne/',
	name: '/ssmw7150cne',
	indexNav: [
		{
			name: '活动信息',
			url: '/index/huodongxinxi',
		},
		{
			name: '公告信息',
			url: '/index/news'
		},
	],
}
